var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"8","height":"7","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 0L4 6.4 0 0z","fill":"#FBBA06","fill-rule":"evenodd"}})])};var toString = function () {return "/builds/yDWsg8mz/0/cloud/front/my-sensefly/src/assets/icons/icn-triangle-down.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icn-triangle-down.svg
// module id = V4Zu
// module chunks = 1